import React, { useState } from "react";
import Logo from "../assets/Logo.png";
import style from "./Screen01.module.css";
import Croatia from "../assets/Croatia.png";
import Slovenia from "../assets/Slovenia.png";
import Serbia from "../assets/Serbia.png";
import Bosnia from "../assets/Bosnia.png";
import Montenegro from "../assets/Montenegro.png";
import Croatiaact from "../assets/Croatiaact.png";
import Sloveniaact from "../assets/Sloveniaact.png";
import Serbiaact from "../assets/Serbiaact.png";
import Bosniaact from "../assets/Bosniaact.png";
import Montenegroact from "../assets/Montenegroact.png";

const Screen01 = ({ phase, setPhase, language, setLanguage }) => {
  const [crobtn, setCrobtn] = useState(Croatia);
  const [slobtn, setSlobtn] = useState(Slovenia);
  const [srbbtn, setSrbbtn] = useState(Serbia);
  const [bihbtn, setBihbtn] = useState(Bosnia);
  const [mnebtn, setMnebtn] = useState(Montenegro);
  const [crostyle, setCrostyle] = useState(style.cro);
  const [slostyle, setSlostyle] = useState(style.slo);
  const [srbstyle, setSrbstyle] = useState(style.srb);
  const [bihstyle, setBihstyle] = useState(style.bih);
  const [mnestyle, setMnestyle] = useState(style.mne);

  const handleCro = () => {
    setCrostyle(style.croact);
    setCrobtn(Croatiaact);
  };
  const handleSlo = () => {
    setSlostyle(style.sloact);
    setSlobtn(Sloveniaact);
  };
  const handleSrb = () => {
    setSrbstyle(style.srbact);
    setSrbbtn(Serbiaact);
  };
  const handleBih = () => {
    setBihstyle(style.bihact);
    setBihbtn(Bosniaact);
  };
  const handleMne = () => {
    setMnestyle(style.mneact);
    setMnebtn(Montenegroact);
  };
  const handleCroLeave = () => {
    setCrostyle(style.cro);
    setCrobtn(Croatia);
  };
  const handleSloLeave = () => {
    setSlostyle(style.slo);
    setSlobtn(Slovenia);
  };
  const handleSrbLeave = () => {
    setSrbstyle(style.srb);
    setSrbbtn(Serbia);
  };
  const handleBihLeave = () => {
    setBihstyle(style.bih);
    setBihbtn(Bosnia);
  };
  const handleMneLeave = () => {
    setMnestyle(style.mne);
    setMnebtn(Montenegro);
  };
  const hadleCroUp = () => {
    setLanguage("Croatia");
    setPhase(1);
  };
    const hadleSloUp = () => {
    setLanguage("Slovenia");
    setPhase(1);
    };
    const hadleSrbUp = () => {
    setLanguage("Serbia");
    setPhase(1);
    };
    const hadleBihUp = () => {
    setLanguage("Bosnia");
    setPhase(1);
    };
    const hadleMneUp = () => {
    setLanguage("Montenegro");
    setPhase(1);
    };
  return (
    <div style={{position: "relative"}}>
      <img src={Logo} alt="Logo" className={style.logo} />
      <div className={style.language}>
        <img
          src={crobtn}
          onPointerDown={handleCro}
          onPointerLeave={handleCroLeave}
            onPointerUp={hadleCroUp}
          alt="cro"
          className={crostyle}
        />
        <img
          src={slobtn}
          alt="slo"
          onPointerDown={handleSlo}
          onPointerLeave={handleSloLeave}
            onPointerUp={hadleSloUp}
          className={slostyle}
        />
        <img
          src={srbbtn}
          alt="srb"
          onPointerDown={handleSrb}
          onPointerLeave={handleSrbLeave}
            onPointerUp={hadleSrbUp}
          className={srbstyle}
        />
        <img
          src={bihbtn}
          alt="bih"
          onPointerDown={handleBih}
          onPointerLeave={handleBihLeave}
            onPointerUp={hadleBihUp}
          className={bihstyle}
        />
        <img
          src={mnebtn}
          alt="mne"
          onPointerDown={handleMne}
          onPointerLeave={handleMneLeave}
            onPointerUp={hadleMneUp}
          className={mnestyle}
        />
      </div>
      {/*  */}
    </div>
  );
};

export default Screen01;
